import { render, staticRenderFns } from "./KeywordTagEditor.vue?vue&type=template&id=f31902da&scoped=true"
import script from "./KeywordTagEditor.vue?vue&type=script&lang=js"
export * from "./KeywordTagEditor.vue?vue&type=script&lang=js"
import style0 from "./KeywordTagEditor.vue?vue&type=style&index=0&id=f31902da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31902da",
  null
  
)

export default component.exports